import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LoginForm from '../forms/LoginForm'
import LoginForgotPasswordDialog from './LoginForgotPasswordDialog'
import { ALLOW_GUEST } from '../config/constants'
import { getBrand } from '../selectors/brandSelector'

import auth0 from 'auth0-js'
import {
  CLIENT_ID,
  CONNECTION,
  DOMAIN,
  REDIRECT_URI,
  RESPONSE_TYPE,
  SCOPE
} from '../config/constants'
import Logo from '../assets/logo'

// const REDIRECT_URI = 'http://localhost:6060/#!/LoginDialog'

const styles = {
  logo: {
    display: 'flex',
    justifyContent: 'center'
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  forgotPassword: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  error: {
    textAlign: 'center'
  }
}

const webAuth = new auth0.WebAuth({
  allowedConnections: ['Username-Password-Authentication', 'google-oauth2'],
  clientID: CLIENT_ID,
  domain: DOMAIN,
  redirectUri: REDIRECT_URI,
  responseType: RESPONSE_TYPE,
  // responseType: 'id_token token',
  // responseMode: 'web_message',
  scope: SCOPE,
  allowSignUp: false
})

class LoginDialog extends Component {
  state = {
    response: null,
    forgotPasswordDialogOpen: false
  }

  handleSubmit = props => {
    const { email, password } = props
    const { onLoginFailed } = this.props
    console.log(onLoginFailed)

    webAuth.login({
      realm: 'Username-Password-Authentication',
      email: email,
      password: password
    }, (error, authResult) => {

      onLoginFailed(error)
    })
  }

  handleGuestSubmit = props => {
    webAuth.login({
      realm: 'Username-Password-Authentication',
      email: getBrand() === 'ArcticCrowdSource' ? 'arctic@c-core.ca' : 'guest@c-core.ca',
      password: 'guest'
    }, (error, authResult) => {
      console.log(error)
      console.log(authResult)
    })
  }

  handleForgotPassword = props => {
    const { email } = props

    if (email) {
      webAuth.changePassword({
        connection: CONNECTION,
        email: email,
      }, (error, authResult) => {
        console.log(error)
        console.log(authResult)
        if (authResult) {
          this.setState({ forgotPasswordDialogOpen: true, email })
        }
      })
    }
  }

  handleClear = () => {
    console.log('handle clear')
  }

  handleForgotPasswordDialogClosed = () => {
    this.setState({ forgotPasswordDialogOpen: false })
  }

  render () {
    const { classes, error } = this.props
    const { forgotPasswordDialogOpen, email } = this.state

    console.log('error')
    console.log(error)

    return(
      <div>
      <Card>
        <CardContent className={classes.logo}>
          <img src={Logo} height='80px'/>
        </CardContent>
        <CardContent>
          {error && <div className={classes.error} >{error.description}</div>}
          <LoginForm onSubmit={this.handleSubmit} handleGuestSubmit={this.handleGuestSubmit} handleForgotPassword={this.handleForgotPassword} allowGuest={ALLOW_GUEST} />
        </CardContent>
      </Card>
      <LoginForgotPasswordDialog open={forgotPasswordDialogOpen} handleClose={this.handleForgotPasswordDialogClosed} email={email} />
      </div>
    )
  }
}

export default withStyles(styles)(LoginDialog)



// WEBPACK FOOTER //
// ./src/components/LoginDialog.js